import React from "react";
import ReactDOM from "react-dom";
import { action, observable, reaction } from "mobx";
import { observer } from "mobx-react";
import { initializer } from "sulu-admin-bundle/services";
import userStore from "sulu-admin-bundle/stores/userStore";
import PrivacyConsentDialog from "./PrivacyConsentDialog";

const CONTAINER_ID = "privacy-consent-overlay-root";
const CONFIG_KEY = "privacy";

/**
 * Renders a blocking overlay whenever the current logged-in user has not
 * accepted the current privacy policy (flagged by the server via the
 * "privacy" admin config slice as needsAccept === true). Consent is
 * captured via POST /admin/api/privacy-consent; rejection triggers logout.
 */
@observer
class PrivacyConsentOverlay extends React.Component {
    @observable accepted = false;

    disposeLoggedInReaction = reaction(
        () => userStore.loggedIn,
        (loggedIn) => {
            if (!loggedIn) {
                this.resetAccepted();
            }
        },
    );

    @action resetAccepted = () => {
        this.accepted = false;
    };

    @action handleAccepted = () => {
        this.accepted = true;
    };

    handleRejected = () => {
        userStore.logout().finally(() => {
            window.location.href = "/admin/";
        });
    };

    componentWillUnmount() {
        this.disposeLoggedInReaction();
    }

    render() {
        const { loggedIn, user } = userStore;

        if (!loggedIn || !user) {
            return null;
        }

        const bundleConfig =
            (initializer.config && initializer.config[CONFIG_KEY]) || {};
        const needsAccept = bundleConfig.needsAccept === true && !this.accepted;

        if (!needsAccept) {
            return null;
        }

        return (
            <PrivacyConsentDialog
                onAccepted={this.handleAccepted}
                onRejected={this.handleRejected}
                policyUrl={bundleConfig.url || null}
            />
        );
    }
}

export default function mountPrivacyConsentOverlay() {
    const container = document.createElement("div");
    container.id = CONTAINER_ID;
    document.body.appendChild(container);

    ReactDOM.render(<PrivacyConsentOverlay />, container);
}
